import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Waveform, ArrowRight } from "@phosphor-icons/react";
import { API } from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";

export default function SharedVideo() {
  const { shareId } = useParams();
  const navigate = useNavigate();
  const { t } = useLang();
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch(`${API}/vshare/${shareId}/meta`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setMeta)
      .catch(() => setError(true));
  }, [shareId]);

  return (
    <div className="min-h-screen flex flex-col" data-testid="shared-video-page">
      <nav className="flex items-center px-8 py-6 max-w-[1100px] mx-auto w-full">
        <div className="flex items-center gap-2.5 cursor-pointer" onClick={() => navigate("/")}>
          <div className="w-8 h-8 rounded-lg bg-[color:var(--accent)] grid place-items-center">
            <Waveform size={18} weight="fill" color="white" />
          </div>
          <span className="font-display font-bold text-xl tracking-tight">AuraFX</span>
        </div>
      </nav>
      <main className="flex-1 flex items-center justify-center px-6 pb-16">
        <div className="w-full max-w-2xl">
          {error ? (
            <p className="text-center text-white/60">404</p>
          ) : !meta ? (
            <p className="text-center text-white/40 text-sm">…</p>
          ) : (
            <div className="glass rounded-2xl border border-white/10 p-6" data-testid="shared-video-card">
              <p className="text-[10px] font-mono-num uppercase tracking-widest text-white/40 mb-3">
                AUTO-FOLEY · {t("shShared")}
              </p>
              <video
                data-testid="shared-video-player"
                controls
                src={`${API}/vshare/${shareId}/video`}
                className="w-full rounded-xl bg-black max-h-[400px]"
              />
              {meta.scene && <p className="mt-4 font-display font-semibold">{meta.scene}</p>}
              <div className="mt-6 pt-5 border-t border-white/10 text-center">
                <p className="text-sm text-white/70 max-w-md mx-auto">{t("vShareCta")}</p>
                <button
                  data-testid="shared-video-cta"
                  onClick={() => navigate("/")}
                  className="btn-primary inline-flex items-center gap-2 px-6 py-3 rounded-full font-medium mt-4"
                >
                  {t("shCtaBtn")} <ArrowRight size={16} weight="bold" />
                </button>
              </div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
